/***
 * 创建人：
 * 时间：2021-1-05
 * 描述：关系新增、编辑
 * 可编辑关系
 * 更新说明:
 */
import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { KmsService } from '../../kms.service';
import { InstanceModuleService } from '../../serves/instance/instance.module';
import { SwMassageBoxService } from '../../../../librarys/serves/sw-massage-box.service';
import { SwModalframeComponent } from '../../../../librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { KmsEnum } from '../../serves/kms-enum';
import { environment } from 'src/environments/environment';
declare var $;
@Component({
    selector: 'app-relation-component',
    templateUrl: './relation-component.component.html',
    styleUrls: ['./relation-component.component.css']
})
export class RelationComponentComponent implements OnInit {
    // 接收父组件的数据
    @Input() param: any;
    // 接收父组件的数据：实体添加入口
    @Input() addPath:string = 'instance';
    // 是否在图谱中展示
    @Input() isFromGraph = false;
    // 抛出事件
    @Output() callback = new EventEmitter();
    // 向父组件传值
    @Output() componentState = new EventEmitter();
    @ViewChild('modal') modal: SwModalframeComponent;
    // 概念模型数据
    ontologyTreeDatas = [];
    // 概念模型树，默认不可选中的父级概念结点
    readonlySelfIds = [];
    // 概念模型树，选中概念名称
    selectConceptName = {
        source: '',
        target: ''
    }
    // 关系树
    relationTreeData = [];
    // 关系树，默认不可选中的父级关系结点
    readonlyRetionSelfIds = ['0'];
    // 关系详细数据
    relationDatas = {
        // 起始实体数据信息
        sourceProperties: {
            nodeName: '',
            conceptId: '',
            conceptName: '',
        },
        // 指向实体数据信息
        targetProperties: {
            nodeName: '',
            conceptId: '',
            conceptName: '',
        },
        // 关联关系数据
        properties: {
            startDate: '',  // 起始时间
            startDateNote: '',  // 起始时间备注
            endDate: '',  // 结束时间
            endDateNote: '',  // 结束时间备注
            parentId: '',  // 关系父级ID
            relationshipId: '',  // 关系ID
            relationshipName: "", // 关系名称
            reverseRelationName: "", // 反向关系名称
            relationAlias: "",  // 关系简称 正向
            reverseRelationAlias: "", // 关系简称 反向
            uuid: '',  // 当前数据ID
            materialId:'', // 关系来源
            description: "", // 关联备注
            sourceMaterial:'',
            pageNum:null,
            relPageNum:null,
            dataSource:''
        },
        sourceUUID: '',  // 起始实体ID
        targetUUID: '',  // 指向实体ID
    }
    // 表单时间 验证失败的字段名数组
    errorList = [];
    // 表单时间 月 数据
    monthArr = new Array(12).fill('').map( (item, index) => index+1);
    // 表单时间 天 数据
    dayArr = [];
    // 概念和实体输入框是否可点击
    isDisable = true;
    // 保存按钮是否可用
    clickEnable = true;
    // 是否展示素材列表
    showMaterials = false;
    keyword = '';
    materialList = [];
    // 数据来源是否必填
    isSourceRequired = environment.isSourceRequired;
    materialCategory = "FILE_TYPE_DOCUMENT";
    fileCategoryOptions = [];
    constructor(
        private kmsService: KmsService,
        private message: SwMassageBoxService,
        private instanceModuleService: InstanceModuleService,
    ) {}

    ngOnInit() {
        this.fileCategoryOptions = [{ id: "FILE_TYPE_ALL", text: "全部" }];
        this.fileCategoryOptions = this.fileCategoryOptions.concat(
          this.instanceModuleService.getResourceTypeOptions()
        );
        this.getConceptTree();
    }

    ngOnChanges() {
        // 关系新增
        if (this.param.upOrAdd === 'Add') {
            this.isDisable = false;
            // 判断是否为从图谱中添加节点，是，则带入默认起始节点数据
            if(this.param.relationData && this.param.relationData.isGraghAdd){
                this.clearData();
                this.relationDatas.sourceProperties.conceptId = this.param.relationData.sourceConceptId;
                this.relationDatas.sourceProperties.nodeName = this.param.relationData.sourceNodeName;
                this.relationDatas.sourceUUID = this.param.relationData.sourceUUID;
                this.selectConceptName.source = this.param.relationData.sourceConceptName;
            }
        }
        // 关系编辑 
        if (this.param.upOrAdd === 'Edit') {
            this.isDisable = true;
            let params = {
                startNodeId: this.param.relationData.sourceUUID,
                uuid: this.param.relationData.properties.uuid,
            }
            this.getRelationshipById(params);
        }
    }

    // 清除页面数据
    clearData(){
        this.relationDatas = {
            // 起始实体数据信息
            sourceProperties: {
                nodeName: '',
                conceptId: '',
                conceptName: '',
            },
            // 指向实体数据信息
            targetProperties: {
                nodeName: '',
                conceptId: '',
                conceptName: '',
            },
            // 关联关系数据
            properties: {
                startDate: '',  // 起始时间
                startDateNote: '',  // 起始时间备注
                endDate: '',  // 结束时间
                endDateNote: '',  // 结束时间备注
                parentId: '',  // 关系父级ID
                relationshipId: '',  // 关系ID
                relationshipName: "", // 关系名称
                reverseRelationName: "", // 反向关系名称
                relationAlias: "",  // 关系简称 正向
                reverseRelationAlias: "", // 关系简称 反向
                uuid: '',  // 当前数据ID
                materialId:'', // 关系来源
                description: "", // 关联备注
                sourceMaterial:'',
                pageNum:null,
                relPageNum:null,
                dataSource:''
            },
            sourceUUID: '',  // 起始实体ID
            targetUUID: '',  // 指向实体ID
        }
    }

    // 根据关系ID查询关系详细数据
    getRelationshipById(params) {
        this.kmsService.getRelationshipById(params).subscribe(
            result => {
                if (result.code == 200) {
                    let datas = result.data;
                    this.relationDatas = datas;
                    let properties = this.relationDatas.properties ? this.relationDatas.properties : null;
                    this.relationDatas.properties.pageNum = properties.pageNum && properties.pageNum > 0 ? properties.pageNum : null;
                    this.relationDatas.properties.relPageNum = properties.relPageNum && properties.relPageNum > 0 ? properties.relPageNum : null;
                    this.getRelationTreeData();
                } else {
                    this.message.waring("数据错误，请稍后再试！");
                }
            }
        )
    }

    // 查询概念数据
    getConceptTree() {
        this.kmsService.getConceptTreeData({}).subscribe(
            data => {
                if (data.code == 200) {
                    if (!data.data) {
                        this.ontologyTreeDatas = [];
                    }
                    this.ontologyTreeDatas = data.data;
                    this.readonlySelfIds = ['0'];
                    this.ontologyTreeDatas.forEach(item => {
                        if (!item.parentId) {
                            item.parentId = '0';
                            item.pid = item.parentId;
                        } else {
                            item.pid = item.parentId;
                        }
                        if(this.ontologyTreeDatas.filter(item1 => item1.pid == item.id).length > 0){
                            this.readonlySelfIds.push(item.id);
                        }
                    });
                    const rootNode = {
                      id: "0",
                      pid: null,
                      text: "概念配置",
                    };
                    this.ontologyTreeDatas.push(rootNode);
                }
            }
        );
    }

    // 概念下拉树切换数据
    handleConceptChange(event, type) {
        if (type == 1) {
          // 获取指向概念
          this.relationDatas.targetProperties.conceptId = event.id;
          this.relationDatas.targetProperties.conceptName = event.text;
          // 清空指向实体
          this.relationDatas.targetProperties.nodeName = '';
          this.relationDatas.targetUUID = '';
        } else {
          // 获取起始概念
          this.relationDatas.sourceProperties.conceptId = event.id;
          this.relationDatas.sourceProperties.conceptName = event.text;
          // 清空起始实体
          this.relationDatas.sourceProperties.nodeName = '';
          this.relationDatas.sourceUUID = '';
        }
        // 清空关系
        this.relationTreeData = [];
        this.relationDatas.properties.relationshipId = '';
        this.relationDatas.properties.relationshipName = '';
        this.relationDatas.properties.reverseRelationName = '';
        this.relationDatas.properties.relationAlias = '';
        this.relationDatas.properties.reverseRelationAlias = '';
        this.relationDatas.properties.parentId = '';
        // 如果起始实体概念和指向实体概念都存在
        if (this.relationDatas.sourceProperties.conceptName && this.relationDatas.targetProperties.conceptName) {
          this.getRelationTreeData();
        }
    }

    // 清除起始子概念或指向子概念
    handleConceptClear(event, type) {
        if (type == 1) {
          // 清空指向概念
          this.relationDatas.targetProperties.conceptId = '';
          this.relationDatas.targetProperties.conceptName = '';
          // 清空指向实体
          this.relationDatas.targetProperties.nodeName = '';
          this.relationDatas.targetUUID = '';
        } else {
          // 清空起始概念
          this.relationDatas.sourceProperties.conceptId = '';
          this.relationDatas.sourceProperties.conceptName = '';
          // 清空起始实体
          this.relationDatas.sourceProperties.nodeName = '';
          this.relationDatas.sourceUUID = '';
        }
        // 清空关系
        this.relationTreeData = [];
        this.relationDatas.properties.relationshipId = '';
        this.relationDatas.properties.relationshipName = '';
        this.relationDatas.properties.reverseRelationName = '';
        this.relationDatas.properties.relationAlias = '';
        this.relationDatas.properties.reverseRelationAlias = '';
        this.relationDatas.properties.parentId = '';
    }

    // 查询关系树数据
    getRelationTreeData() {
        let params = {
          sourceConceptId: this.relationDatas.sourceProperties.conceptId,
          targetConceptId: this.relationDatas.targetProperties.conceptId,
        };
        // 查询左侧关系树数据
        this.kmsService.getRelationTreeListPrefix(params).subscribe(
            data => {
                if (data.code == '200') {
                    if (!data.data) {
                      this.message.danger("当前关系名称不存在！");
                      return;
                    }
                    data.data.forEach(element => {
                      element['text'] = element['reverseName'] ? element['name']+"（"+element['reverseName']+"）" : element['name'];
                    });
                    this.relationTreeData = data.data;
                    this.readonlyRetionSelfIds = ["0"];
                    this.relationTreeData.forEach((item) => {
                      if (!item.pid) {
                        item.pid = "0";
                      }
                      // 根据是否有父级判断是否为概念组节点，概念组节点不可选择
                      if (
                        this.relationTreeData.filter((item1) => item1.id == item.pid)
                          .length == 0
                      ) {
                        this.readonlyRetionSelfIds.push(item.id);
                      }
                    });
                }
            }
        );
    }

    // 关系下拉树切换数据
    handleRelationChange(event) {
        // 赋值当前选中的关系名称
        let items = this.relationTreeData.filter(el => el.id == event.id);
        this.relationDatas.properties.relationshipName = items[0].name;
        this.relationDatas.properties.reverseRelationName = items[0].reverseName;
        this.relationDatas.properties.relationAlias = items[0].relationAlias ? items[0].relationAlias : '';
        this.relationDatas.properties.reverseRelationAlias = items[0].reverseRelationAlias ? items[0].reverseRelationAlias : '';
    }

    // 实体下拉树切换数据
    handleInstanceChange(event,type) {
        if (type == 1) {
          this.relationDatas.targetProperties.nodeName = event.text;
        } else {
          this.relationDatas.sourceProperties.nodeName = event.text;
        }
    }

    // 表单，日期年月日赋值
    getYearOrMonthOrDay(key, dateStr) {
        let data;
        if(!dateStr) {
            data = {
                'year':'',
                'month':'',
                'day':''
            }
        } else {
            const dateArr = dateStr.split('/');
            const len = dateArr.length;
            data = {
                'year':len > 0 ? dateArr[0] : '',
                'month':len > 1 ? dateArr[1] : '',
                'day':len > 2 ? dateArr[2] : ''
            }
            if (dateArr[0] && dateArr[1]) {
                this.dayArr = this.instanceModuleService.getDayDatas(dateArr[0], dateArr[1]);
            }
        }
        return data[key];
    }

    // 表单，获取年号
    getTime(keyName) {
        let parent = $('input[name="' + keyName + '"]').parent();
        const value = parent.find('.year').val();
        if (value) {
            if (value > 1949) {
                if (keyName == 'startDate') {
                    // 发生时间
                    this.relationDatas.properties.startDateNote = `${value}年`;
                } else {
                    // 结束时间
                    this.relationDatas.properties.endDateNote = `${value}年`;
                }
            }else{
                this.kmsService.getInstanceTimeNoteByYear(value).subscribe(
                    data => {
                        if (data.code == '200') {
                            const res = data.data;
                            if (keyName == 'startDate') {
                                // 发生时间
                                this.relationDatas.properties.startDateNote = res;
                            } else {
                                // 结束时间
                                this.relationDatas.properties.endDateNote = res;
                            }
                        } else {
                            console.log(data.msg);
                        }
                    }
                );
            }
        }
    }

    // 表单，监听时间输入框的变化，判断是否合法
    getDateStr(keyName) {

        let parent = $('input[name="' + keyName + '"]').parent();
        const yearValue = parent.find('.year').val();
        const monthValue = parent.find('.month').val();
        const dayValue = parent.find('.day').val();

        let res = this.instanceModuleService.validateTime(yearValue, monthValue, dayValue);
        if (keyName == 'startDate') {
            // 发生时间
            this.relationDatas.properties.startDate = res.timeStr;
        } else {
            // 结束时间
            this.relationDatas.properties.endDate = res.timeStr;
        }
        
        let item = {};
        item[keyName] = res.timeStr;
        if (!res.isValid) {
            if (this.errorList.indexOf(keyName) < 0) {
                this.errorList.push(keyName);
                parent.parent().find('.tip-error').removeClass('hidden');
                parent.find('.year,.month,.day').addClass('input-error');
            }
        } else {
            const index = this.errorList.indexOf(keyName);
            if (index >= 0) {
                this.errorList.splice(index, 1);
                parent.parent().find('.tip-error').addClass('hidden');
                parent.find('.year,.month,.day').removeClass('input-error');
            }
        }
    }

    // 关系关联备注填充方法
    handleFillClick() {
        this.relationDatas.properties.description = this.param.textStr;
        this.relationDatas.properties.dataSource = this.param.source;
    }

    toggleMaterial(state){
      this.showMaterials = state;
    }
  
    setMaterial(item){
      this.relationDatas.properties.materialId = item.materialId;
      this.relationDatas.properties.sourceMaterial = item.materialTitle;
      this.showMaterials = false;
    }
  
    //enter键触发搜索
    enterSearch(event) {
      if (event.keyCode == '13') {
        this.searchMaterial();
      }
    }
  
    searchMaterial(){
      let keyword = $.trim(this.keyword);
      if(!keyword){
        this.message.danger('请输入素材名称！');
        return;
      }
      let params = {
        current: 1,
        size: 30,
        materialTitle: keyword,
        materialCategory: this.materialCategory == 'FILE_TYPE_ALL' ? '' : this.materialCategory
      }
      this.kmsService.queryMaterialList(params).subscribe(
        data => {
          if (data.code == '200') {
            this.materialList = data.data.records ? data.data.records : [];
          } else {
            console.log(data.msg);
          }
        }
      );
    }
  
    clear(){
      this.relationDatas.properties.materialId = '';
      this.relationDatas.properties.sourceMaterial = '';
    }

  // 新增、编辑关系（单条操作)
    onSubmit() {
        this.clickEnable = false;
        let params = {
          "relationship": this.relationDatas.properties,
          "sourceUUID": this.relationDatas.sourceUUID,
          "targetName": this.relationDatas.targetProperties.nodeName,
          "targetUUID": this.relationDatas.targetUUID
        }
        this.kmsService.saveRelationshipUpdate(params).subscribe(
            data => {
                if (data.code == '200') {
                    this.message.success('保存成功！');
                    this.componentState.emit('save');
                } else {
                    this.message.waring(data.msg);
                }
            }
        );
    }

    // 关闭按钮
    handleBackClick() {
        this.componentState.emit('close');
        this.clearData();
    }
}
